<template>
  <v-menu offset-y v-if="items.length">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :color="color" v-bind="attrs" v-on="on" :disabled="disabled" depressed min-width="38" class="mr-1 px-0" :small="btnSize == 'small'">
        <v-icon v-if="icon">{{ icon }}</v-icon>
        <span v-if="$vuetify.breakpoint[`${size}AndUp`] && title" class="px-2">{{ title }} </span>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(item, index) in items" :key="index" @click="$emit('click', item)" :disabled="item.disabled">
        <v-list-item-icon v-if="item.icon">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    size: { type: String, default: "sm" },
    btnSize: { type: String, default: "" },

    color: String,
    title: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    items: {
      type: Array,
      default: () => [],
    },
    icon: { type: String, default: "mdi-debug-step-over" },
  },
};
</script>
